import React from 'react';
import './ModeSelector.css';

function ModeSelector({ onSelect, onBack }) {
  const modes = [
    {
      id: 'beginner',
      name: 'Beginner Mode',
      icon: '🌱',
      description: 'Perfect for first-time learners. Includes helpful hints and guidance.',
      features: ['Hints available', 'Free response', 'Detailed explanations']
    },
    {
      id: 'multiple-choice',
      name: 'Multiple Choice',
      icon: '✅',
      description: 'Test your knowledge with multiple choice questions.',
      features: ['4 answer options', 'Instant feedback', 'Progress tracking']
    },
    {
      id: 'free-response',
      name: 'Free Response',
      icon: '✍️',
      description: 'Challenge yourself with free response questions. No hints!',
      features: ['Type your answer', 'Exact matching', 'Advanced practice']
    }
  ];

  return (
    <div className="mode-selector">
      <button className="back-button" onClick={onBack}>
        ← Back to Study Sets
      </button>
      
      <h2>Select Your Study Mode</h2>
      <p className="subtitle">Choose the learning style that works best for you</p>

      <div className="modes-grid">
        {modes.map((mode) => (
          <div
            key={mode.id}
            className="mode-card"
            onClick={() => onSelect(mode.id)}
          >
            <div className="mode-icon">{mode.icon}</div>
            <h3>{mode.name}</h3>
            <p className="mode-description">{mode.description}</p>
            <ul className="feature-list">
              {mode.features.map((feature, idx) => (
                <li key={idx}>
                  <span className="checkmark">✓</span> {feature}
                </li>
              ))}
            </ul>
            <button className="start-button">Start Learning</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ModeSelector;
